    (function(angular, schoolwork12) {
	'use strict';
	
	schoolwork12.app.mailTemplate = {
        name: 'schoolwork12.mailTemplate',
        controllers: {
            manageMailTemplate : 'mailTemplateCtrl',
            addMailTemplate : 'addMailTemplateCtrl',
            editMailTemplate : 'editMailTemplateCtrl',
        },
        routes: {
            manageMailTemplate: '/manage-school-mail-templates',
            addMailTemplate: '/add-school-mail-template',
            editMailTemplate: '/edit-school-mail-template'
        },
        templates : {
            manageMailTemplate: 'mailTemplates/html/manageMailTemplate.html',
            addMailTemplate : 'mailTemplates/html/addMailTemplate.html',
            editMailTemplate : 'mailTemplates/html/editMailTemplate.html',

        },
        services: {
            mailTemplateSvc: 'mailTemplateSvc'        
        },
        endpoints: {
            getMailTemplateEndpoint: schoolwork12.app.endpoint.concat('/school/level/template/search'),
            saveSchoolTemplateEndpoint: schoolwork12.app.endpoint.concat('/school/level/template/'),
        },
        errorMessages: {
            invalidCreatedDt: "A valid date (MM/DD/YYYY) must be entered to search templates by Created Date.",
            selectCreatedDt: "Select Created Date Qualifier.",
            invalidCreatedDtQualifier:"Specified a Created Date qualifier without specifying a date for the field.",
            invalidModifiedDt: "A valid date (MM/DD/YYYY) must be entered to search templates by Modified Date.",
            selectModifiedDt: "Select Modified Date Qualifier.",
            invalidModifiedDtQualifier:"Specified a Modified Date qualifier without specifying a date for the field.",
            
        },

	};
	
    angular.module(schoolwork12.app.mailTemplate.name, ['ui.grid', 'ui.grid.resizeColumns', 'ui.grid.pagination','ngTagsInput']);
	 
}(angular, schoolwork12));
